module.exports = __webpack_public_path__ + "media/customizations/shellstonelife/logo-d97bc1c39fb63a9af18f7cdfa63e72f8.png";